// extracted by mini-css-extract-plugin
export default {"icon":"cells_icon__RcFeh","cell":"cells_cell__xR7NF","link":"cells_link__hUmvr"};